import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReportList from "../../../common/ReportList";
import Constants from "../../../../common/Constants";
import { formatDateTime } from "../../../../common/Validations";

const ConsumptionQuantityReports = () => {
  const { t } = useTranslation();
  const [displayFilter, setDisplayFilter] = useState(false);

  const columnsData = [
    {
      name: t("msg_reports.msg_consumption_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
      conditionalCellStyles: [
        {
          when: (row) => true, // apply to all rows
          style: {
            position: "sticky",
            left: "0px",
            background: "#fff",
            zIndex: 2,
            boxShadow: "2px 0 5px -2px #ddd",
          },
        },
      ],
    },
    {
      name: t("msg_reports.msg_consumption_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.sizeCode} </p>
          <p className="m-0 p-0 ">{row.sizeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.col_department"),
      selector: (row) => row.deptCode,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.deptCode} </p>
          <p className="m-0 p-0 ">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.col_machine"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "130px",
      cell: (row) => (
        <>
          {row.machineCode ? (
            <span className="fw-bold">{row.machineCode}</span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.consumption"),
      selector: (row) => row.consumableSize,
      sortable: true,
      width: "190px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.consumptionType} </p>
          <p className="m-0 p-0 ">{row.consumableSize} </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.jobcard_Count"),
      selector: (row) => row.okCount,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {row.okCount}
          </span>
          <span className="bg-table-status bg-table-danger-status">
            {row.rejectCount}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.col_quantity"),
      selector: (row) => row.quantity,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.quantity}
          </span>
        </>
      ),
    },   
    {
      name: t("msg_reports.msg_consumption_report.created_date"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {formatDateTime(row.dbDateTimeCreated)}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_consumption_report.created_user"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">
            {row.loginUserId}- {row.loginUserName}
          </p>
        </div>
      ),
    },
  ];

  return (
    <main className="generatejobcard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_reports.msg_consumption_report.report_title")}
            </h2>
            <p className="subText">
              {t("msg_reports.msg_consumption_report.details_page")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="leftSide">
          <Button
            type="button"
            variant="primary"
            size="lg"
            className="btn btn-primary float-right searchFilter-btn"
            onClick={() => setDisplayFilter(!displayFilter)}
          >
            <i className="bi bi-filter"> </i>
          </Button>
        </Col>
        <hr />
      </Row>
      <div>
        <ReportList
          selectableRows={false}
          // reloadFlag={reloadFlag}
          columnsData={columnsData}
          displayProdStatusFilter={displayFilter}
          // handleSelections={handleSelectedRowsChange}
          resetFilerBox={setDisplayFilter}
          pageName={t(
            "msg_reports.msg_consumption_report.reports_pageName",
          )}
          pageURL={Constants.REPORTS.CONSUMPTIONQTYREPORT.list}
          name={Constants.REPORTS.CONSUMPTIONQTYREPORT.name}
        />
      </div>
    </main>
  );
};

export default ConsumptionQuantityReports;
